import React, { Component } from 'react';
import { Modal, Radio, message, DatePicker } from 'antd';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import addToDownloadSite from '../../../shared/addToDownloadSite';
import moment from 'moment';

const RadioGroup = Radio.Group;
const monthFormat = 'YYYY-MM';
const { MonthPicker } = DatePicker;

class ExportModal extends Component {
    state = {
        visible: false,
        type: undefined,
        beginYearMonth: undefined,
        endYearMonth: undefined,
    }

    show = () => {
        const { invState } = sessionStorage;
        if (invState != 0) {
            this.export('single');
        } else {
            this.setState({ visible: true });
        }
    }

    hide = () => {
        this.setState({
            visible: false,
            type: undefined,
        });
    }

    confirm = () => {
        const { type, beginYearMonth, endYearMonth } = this.state;
        if(!type){
            message.warning('请选择需要导出的内容');
            return;
        }
        if (type === 'single_no_invoice' && (!beginYearMonth || !endYearMonth)) {
            message.warning('请选择统计时间');
            return;
        }

        this.export(type);
        this.hide();
    }

    export = (type) => {
        const { searchParams } = this.props;
        const { remittanceNum, paymentProgressIds = [] } = searchParams;
        const { beginYearMonth, endYearMonth } = this.state;

        const params = {
            ...searchParams,
            remittanceNum: (remittanceNum || remittanceNum === 0) ? `第${remittanceNum}笔` : '',
            paymentProgressIds: paymentProgressIds.join(','),
        };
        const url = API_URL.contract.exportContractRemittanceList;
        if (type === 'single' || type === 'single_no_invoice') {
            const options = {
                method: 'POST',
                url: url,
                data: {
                    ...params,
                    offset: 1,
                    type,
                    beginYearMonth: beginYearMonth ? Number(moment(beginYearMonth).format('YYYYMM')) : undefined,
                    endYearMonth: endYearMonth ? Number(moment(endYearMonth).format('YYYYMM')) : undefined,
                },
                dataType: 'json',
                doneResult: res => {
                    message.success(res.success);
                },
            };
            $.sendRequest(options);
        } else {
            addToDownloadSite({ ...params, type }, url, 'REMITTANCE_APPLICATION_MULTI');
        }
    }

    handleChange = (value, key) => {
        if (key == 'type') {
            this.setState({ 
                beginYearMonth: undefined,
                endYearMonth: undefined,
            });
        }
        this.setState({ [key]: value });
    }

    render() {
        const { visible, type, beginYearMonth, endYearMonth } = this.state;
        const radioStyle = {
            display: 'block',
            paddingLeft: 10,
            height: 30,
            lineHeight: '30px',
        };
        return (
            <Modal
                title="导出"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
            >
                <div className="cont-cont" style={{ padding: '30px 20px' }}>
                    <ul className="preview-list">
                        <li className="preview-item">
                            <div className="item" style={{ width: '35%' }}>
                                <label className="ui-label" style={{width: 160, marginLeft: -30}} >请选择需要导出的内容</label>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item checkBoxchildren" >
                                <RadioGroup onChange={e => this.handleChange(e.target.value, 'type')} value={type}>
                                    <Radio value="single" style={radioStyle}>合同请款记录（单表头&所有数据）</Radio>
                                    <Radio value="single_no_invoice" style={radioStyle}>合同请款记录（单表头&无开票记录）</Radio>
                                    {type === 'single_no_invoice' &&
                                        <div style={{ margin: '10px 25px' }}>
                                        <div className="filter-item">
                                            <label className="filter-label" style={{ marginRight: 7 }}>统计时间</label>
                                            <MonthPicker
                                                format={monthFormat}
                                                allowClear={false}
                                                value={beginYearMonth ? moment(beginYearMonth) : ''}
                                                onChange={(date, dateString) => this.handleChange(dateString, 'beginYearMonth')}
                                                style={{width: 100, verticalAlign: 'middle'}}
                                            />
                                            <label className="filter-label">~</label>
                                            <MonthPicker
                                                format={monthFormat}
                                                allowClear={false}
                                                value={endYearMonth ? moment(endYearMonth) : ''}
                                                onChange={(date, dateString) => this.handleChange(dateString, 'endYearMonth')}
                                                style={{width: 100, verticalAlign: 'middle'}}
                                            />
                                        </div>
                                    </div>
                                    }
                                    <Radio value="multiply" style={radioStyle}>合同请款记录（双表头）</Radio>
                                </RadioGroup>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        )
    }
}

export default ExportModal;


// WEBPACK FOOTER //
// ./src/components/contractManagement/requestRecord/components/ExportModal.js